import * as React from "react";
import * as Helpers from "../helpers";
import { StepWizardChildProps } from "react-step-wizard";
import InputText from "../Components/InputText";
import Steps from "./steps";
import PageNavigation from "../Components/PageNavigation";

export type ContactDetailsFields = {
    contact_first_name: string;
    contact_last_name: string;
    contact_phone: string;
    contact_email: string;
}

export class ContactDetails extends React.Component<PageProps<ContactDetailsFields> & Partial<StepWizardChildProps>, PageState>{
    constructor(props: PageProps<ContactDetailsFields>) {
        super(props);

        this.state = {
            validation_triggered: false
        };
    }

    triggerValidation()
    {
        const page_fields = [ "contact_first_name", "contact_last_name", "contact_phone", "contact_email" ];
        return Helpers.TriggerValidation(this, page_fields, this.props.required, this.props.form_values);
    }

    submit() {
        const validation_result = this.triggerValidation();
        if (!validation_result) {
            return;
        }

        if (this.props.nextStep) {
            this.props.nextStep();
        }
    }

    render() {
        let scrolled = false;
        let getScrolled = () => scrolled;
        let setScrolled = () => { scrolled = true; };

        return <div>
            <div className="row">
                <div className="col-md-6">
                    <InputText
                        label="First name"
                        name="contact_first_name"
                        value={this.props.form_values.contact_first_name}
                        required={this.props.required.contact_first_name}
                        validation_message="Please enter your first name."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                    />
                </div>
                <div className="col-md-6">
                    <InputText
                        label="Last name"
                        name="contact_last_name"
                        value={this.props.form_values.contact_last_name}
                        required={this.props.required.contact_last_name}
                        validation_message="Please enter your last name."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <InputText
                        label="Phone"
                        name="contact_phone"
                        type="tel"
                        value={this.props.form_values.contact_phone}
                        required={this.props.required.contact_phone}
                        validation_message="Please enter your phone number."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                    />
                </div>
                <div className="col-md-6">
                    <InputText
                        label="Email"
                        name="contact_email"
                        type="email"
                        value={this.props.form_values.contact_email}
                        required={this.props.required.contact_email}
                        validation_message="Please enter your email address."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Steps totalSteps={this.props.totalSteps!} currentStep={this.props.currentStep!} />
                </div>
                <div className="col-md-6">
                    <PageNavigation allowPrevious={false} allowNext={true} useSubmitForNext={false} onNext={() => this.submit()} />
                </div>
            </div>
        </div>
    }
}